
import React, { useState, useEffect, Fragment, useRef } from 'react'
import {
  Select, Form, Input, Button, Modal,
  Upload, Row, Col, DatePicker, message, InputNumber, Space, Radio, TreeSelect
} from "antd";
const { RangePicker } = DatePicker;
import RoleApi from '@api/role'

import ResourceApi from '@api/resource'
import AddModal from '@components/Modal'
import { identifierData } from '@utils/common'
import moment from 'moment';
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import InspectionApi from '@api/inspectionnew'
import { treeConversion, treeIds, extraIds } from '@utils/common'

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option

export default ({ title, visible, formData = null, cancel,stationData }) => {
  const [form] = Form.useForm();
  const [editBool, setEditBool] = useState(false)
  const [resourceTree, setResourceTree] = useState()
  const [formValue, setFormValue] = useState({
    unit: '个周',
    period: 1
  })
  const [loading, setLoading] = useState()
  // 所有的树形id
  const [allIds, setAllIds] = useState([])
  const [isManager, setIsManger] = useState(0)
  // 处理人列表
  const [personItems, setPersonItems] = useState([])
  const [deviceArry,setDeviceArry] = useState([])
  const [patrolItems, setPatrolItems] = useState() 
  const [defectLevelIdArr,setDefectLevelIdArr] = useState([])
  const [sourceIdArr,setSourceIdArr] = useState([])
  const [users, setUsers] = useState([])
  // 保养标准列表
  const [upkeepStand,setUpkeepStand] = useState([])

  const [deviceName, setDeviceName] = useState()
  // 厂站集合
  const [patrolItemParams, setPatrolItemParams] = useState({
    stationId: '',
    type: '',
    materielId: '',
    processunitClassifyId: '',
    processunitId: '',
    deviceClassifyId: '',
  })
  useEffect(() => {
    // 获取人员列表
    if (formData) {
      RoleApi.queryRoleUserByIdentifier({ stationIds: formData.stationId, identifier: identifierData[0] }).then(res => {
        if (res.status == 0 && res.data) {
          setPersonItems(res.data || [])
        }
      })
    } 
    InspectionApi.taskQuery({ pageSize:100,pageNum:1 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setSourceIdArr(res.data.data )
      }
    })
    // 保养标准列表
    InspectionApi.upkeepStandard({ pageNum: 1,pageSize: 100000 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setUpkeepStand(res.data.data || [])
      }
    })
    return () => { }
  }, [])
  useEffect(() => {
    if (patrolItemParams.stationId && patrolItemParams.type === 0) {
      
    }
    return () => { }
  }, [patrolItemParams])

  // 切换厂站，查询巡检项
  const changeStation = (val) => {
    getDatas()
  }
    // 获取模版列表, 获取人员列表
  const getDatas = (id=null) => {
    let stationIds = form.getFieldValue('stationId')?form.getFieldValue('stationId') : id;
    if (stationIds) {
      RoleApi.userByStand({stationId:stationIds}).then(res => {
        let user = []
        res.data.forEach( (key,index) =>{
          for ( var attr in res.data[index] ) {
            res.data[index][attr].map(item => {
              user.push(item)
            })
          }
        })
        setUsers(user)
      })
    }
  }
  const getChild = (arr) => {
    const role = form.getFieldValue('handleRole')
    return arr.map(item => {
      if(item.children && item.children.length > 0){
        item.children = getChild(item.children);
        if(role !='area_manager'){
          item.disabled = item.deviceId?false:true;
        }
        return item;
      } else {
        delete item.children;
        if(role !='area_manager'){
          item.disabled = item.deviceId?false:true;
        }
        return item;
      }

    })
  }
  // 提交
  const submit = () => {
    
    form.validateFields().then(values => {
      if(!values){
        return;
      }
      setLoading(true)

      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))

      let params = {
        createAt: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        beginTime: moment(values.time[0]._d).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(values.time[1]._d).format('YYYY-MM-DD HH:mm:ss'),
        createBy: userInfo.realName,
        deviceId: values.deviceId,
        deviceName: deviceName,
        grease: values.grease,
        handleUserId: values.handleUserId,
        itemContent: values.itemContent,
        stationId: values.stationId,
        taskName: values.taskName,
        oliMass: values.oliMass,
        period: values.period + values.unit,
        upkeepStandardId: values.upkeepStandardId
      }

      if(formData && formData.id){

      } else {
        InspectionApi.upkeepTaskAdd(params).then(res => {
          if (res.status == 0) {
            message.success('添加成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
      
      
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={800} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form preserve={false}
          {...layout}
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
          initialValues={formValue}
        >
          <Col span={18}>
            <Form.Item label="保养任务名称" name="taskName" rules={[{ required: true, message: '请输入保养任务名称' }]}>
                <Input placeholder='请输入保养任务名称' />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='保养厂站'
              name="stationId"
              rules={[{ required: true, message: '请选择保养厂站' }]}
            >
              <Select
                allowClear
                onChange={(val) => changeStation(val)}                
                placeholder="请选择">
                {
                  stationData && stationData.map((item, idx) => {
                    return (
                      <Select.Option value={item.value + ''} key={'stationId-' + idx}>{item.title || item.name}</Select.Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item label="设备" name="deviceId" rules={[{ required: true, message: '请选择设备' }]}>
                <Select
                  placeholder="设备"
                  onChange={ () => { setDeviceName('A-BH0403提升泵1') } }
                >
                  <Option value={0}> A-BH0403提升泵1 </Option>
                </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='处理人'
              name="handleUserId"
              rules={[{ required: true, message: '请选择处理人' }]}
            >
              <Select
                placeholder="请选择">
                 {users.map(item => {
                  return <Select.Option value={item.userId} key={`users-${item.userId}`}>{item.userName}</Select.Option>
                })} 
              </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='保养标准'
              name="upkeepStandardId"
              rules={[{ required: true, message: '请选择保养标准' }]}
            >
              <Select
                placeholder="请选择保养标准">
                 { upkeepStand && upkeepStand.map(item => {
                  return <Select.Option value={item.id} key={item.id}>{item.upkeepStandardName}</Select.Option>
                })} 
              </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item label='保养内容' name="itemContent" rules={[{ required: true, message: '请输入保养内容' }]}>
              <Input.TextArea row={4} placeholder={'请输入保养内容'} />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='截止时间'
              name="time"
              rules={[{ required: true, message: '请输入截止时间' }]}
            > 
              <RangePicker />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item label="油脂" name="grease" rules={[{ required: true, message: '请输入油脂' }]}>
                <Input placeholder='请输入油脂' />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item label="油量" name="oliMass" rules={[{ required: true, message: '请输入油量' }]}>
                <Input placeholder='请输入油量' />
            </Form.Item>
          </Col>
          <Col span={18} className="up-task-period">
              <Form.Item name="period" label="周期" rules={[{ required: true, message: '请输入周期' }]}>
                <InputNumber min={1} max={12} />
              </Form.Item>
              <Form.Item name="unit" className="period-unis">
                <Select>
                  <Option value="个周">个周</Option>
                  <Option value="个月">个月</Option>
                </Select>
              </Form.Item>
          </Col>
        </Form>
      </div>
    </AddModal>
  )

}
